import AbstractSystem from '../all/AbstractSystem';

class NetrangeSystem extends AbstractSystem {
  exit() {
    window.open('/node/homeuser', '_self', '');
    window.close();
  }
}

export default NetrangeSystem;



// WEBPACK FOOTER //
// ./src/devices/netrange/System.js